import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CS_ROUTE_KEYS } from 'utils/constants';

const SettingsIndex = () => {
  const navigate = useNavigate();
  const gotToProfile = () => {
    navigate(`${CS_ROUTE_KEYS.SETTINGS}/${CS_ROUTE_KEYS.PROFILE}`);
  };
  useEffect(() => {
    gotToProfile();
  }, []);

  return <div />;
};

export default SettingsIndex;
